import { render, staticRenderFns } from "./DropzoneFiles.vue?vue&type=template&id=3645a1a1&scoped=true"
import script from "./DropzoneFiles.vue?vue&type=script&lang=js"
export * from "./DropzoneFiles.vue?vue&type=script&lang=js"
import style0 from "./DropzoneFiles.vue?vue&type=style&index=0&id=3645a1a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3645a1a1",
  null
  
)

export default component.exports